var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "app-modal",
    {
      attrs: { titulo: _vm.titulo, width: _vm.width, closeOutside: true },
      on: {
        closeModal: function($event) {
          return _vm.$emit("closeModal")
        }
      }
    },
    [
      _c(
        "template",
        { slot: "body" },
        [
          _vm.documentos
            ? _c(
                "el-carousel",
                {
                  attrs: {
                    loop: _vm.carouselConfig.loop,
                    height: _vm.carouselConfig.height,
                    autoplay: _vm.carouselConfig.autoplay,
                    trigger: _vm.carouselConfig.trigger,
                    arrow: _vm.carouselConfig.arrow,
                    "indicator-position": _vm.carouselConfig.indicatorPosition
                  },
                  on: { change: _vm.changePdf }
                },
                _vm._l(_vm.documentos, function(documento) {
                  return documento.bytes
                    ? _c(
                        "el-carousel-item",
                        { key: documento.id },
                        [
                          _c(_vm.componentViewer, {
                            tag: "component",
                            attrs: { bytes: documento.bytes }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                }),
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("template", { slot: "footer" }, [
        _c(
          "div",
          { staticClass: "flex-end" },
          [
            _c("el-button", { on: { click: _vm.downloadDocument } }, [
              _c("i", { staticClass: "fal fa-file-pdf" }),
              _vm._v(" "),
              _c("span", [
                _vm._v("Exportar " + _vm._s(_vm.isPdf ? "PDF" : "imagem"))
              ])
            ])
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-88cbfab8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-88cbfab8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components(new)/UI/Modals/VisualizarDocumentos/VisualizarDocumentos.vue
// module id = null
// module chunks = 